const IntlCurrencyData = {
    AED: "AED",
    ARS: "$",
    AUD: "$",
    AWG: "ƒ",
    BBD: "Bds$",
    BDT: "৳",
    BGN: "Лв.",
    BHD: "BD",
    BMD: "$",
    BOB: "$",
    BRL: "$",
    BSD: "B$",
    BZD: "$",
    CAD: "$",
    CHF: "CHf",
    CLP: "$",
    CNY: "¥",
    COP: "$",
    CRC: "₡",
    CZK: "Kč",
    DKK: "Kr.",
    DOP: "DOP",
    EUR: "€",
    FJD: "FJ$",
    GBP: "£",
    GIP: "£",
    GTQ: "Q",
    HKD: "$",
    HNL: "L",
    HRK: "kn",
    HUF: "Ft",
    IDR: "Rp",
    ILS: "₪",
    INR: "₹",
    ISK: "kr",
    JMD: "$",
    JOD: "د.ا",
    JPY: "¥",
    KES: "K",
    KRW: "₩",
    KHR: "៛",
    KWD: "KD",
    KYD: "$",
    LKR: "Rs",
    MAD: "DH",
    MNT: "₮",
    MOP: "MOP",
    MVR: "MVR",
    MXN: "$",
    MYR: "RM",
    NGN: "₦",
    NIO: "C$",
    NOK: "kr",
    NZD: "$",
    OMR: "ر.ع.",
    PEN: "$",
    PGK: "K",
    PHP: "₱",
    PKR: "Rs",
    PYG: "$",
    QAR: "QR",
    SAR: "SR",
    SEK: "kr",
    SGD: "$",
    THB: "฿",
    TRY: "₺",
    TTD: "$",
    TWD: "NT$",
    USD: "$",
    UYU: "$",
    VND: "₫",
    XCD: "$",
    ZAR: "R"
}

export default IntlCurrencyData
